/* 🤖 this file was generated by svg-to-ts */
export const svgMinus: {
    name: "minus";
    data: string;
} = {
    name: "minus",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__minus" viewBox="0 0 12 12"><path id="ng__path-minus" fill="none" fill-rule="evenodd" stroke-linecap="round" d="M10 6H2"/></symbol></svg>`,
};
